/* TLR hero — assets/tlr-hero.js */
(function () {
  class TlrHero extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.tlr-hero__slide'));
      this.dots = Array.from(this.querySelectorAll('[data-tlr-hero-dot]'));
      this.index = 0;
      if (this.slides.length < 2) return;

      this.querySelector('[data-tlr-hero-next]')?.addEventListener('click', () => this.go(this.index + 1, true));
      this.querySelector('[data-tlr-hero-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
      this.dots.forEach(d => d.addEventListener('click', () => this.go(parseInt(d.dataset.tlrHeroDot, 10), true)));

      this.bindSwipe();
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      document.addEventListener('visibilitychange', () => document.hidden ? this.stop() : this.start());

      /* Theme editor: jump to the slide being edited */
      document.addEventListener('shopify:block:select', e => {
        if (!this.contains(e.target)) return;
        this.stop();
        this.go(this.slides.indexOf(e.target));
      });
      document.addEventListener('shopify:block:deselect', e => { if (this.contains(e.target)) this.start(); });

      this.start();
    }

    disconnectedCallback() { this.stop(); }

    go(i, manual) {
      const n = this.slides.length;
      this.index = ((i % n) + n) % n;
      this.slides.forEach((s, k) => s.classList.toggle('is-active', k === this.index));
      this.dots.forEach((d, k) => d.classList.toggle('is-active', k === this.index));
      if (manual) { this.stop(); this.start(); }
    }

    start() {
      if (this.dataset.autoplay !== 'true' || this.slides.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.stop();
      this.timer = setInterval(() => this.go(this.index + 1), (parseFloat(this.dataset.interval) || 6) * 1000);
    }

    stop() { clearInterval(this.timer); }

    bindSwipe() {
      let x0 = null;
      this.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; }, { passive: true });
      this.addEventListener('touchend', e => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 45) this.go(this.index + (dx < 0 ? 1 : -1), true);
        x0 = null;
      }, { passive: true });
    }
  }

  if (!customElements.get('tlr-hero')) customElements.define('tlr-hero', TlrHero);
})();
